// Dữ liệu mẫu Mint-M365 (U0 / BOX0 / AUD trong code board; theo TblStaff, UPN che). Không gọi Graph, không có mật khẩu.

export type Tone = 'ok' | 'warn' | 'err' | 'mute';
export type Acc = 'on' | 'off' | 'none';
export interface M365User { un: string; fn: string; seat: string; app: Acc; m365: Acc; lic: string[]; mfa: boolean; photo: 'both' | 'logi' | 'm365' | 'none'; flags: [string, Tone][] }

export const LIC: Record<string, string> = { BSTD: 'M365 Business Standard', BBAS: 'M365 Business Basic', EXO: 'Exchange Online (Plan 1)' };

export const USERS: M365User[] = ([
  ['DAVID', 'Nguyễn Trường Giang', 'SALE · SALE-MGR', 'on', 'on', ['BSTD'], true, 'both', []],
  ['PHILIP', 'Nguyễn Trường Sơn', 'BOD · BOD-DIR', 'on', 'on', ['BSTD'], true, 'both', []],
  ['HANHLTM', 'Lê Thị Mỹ Hạnh', 'ACC · ACC-CP', 'on', 'on', ['BSTD'], true, 'logi', [['Ảnh chưa đẩy M365', 'mute']]],
  ['PHONGNT', 'Nguyễn Thanh Phong', 'TRD · TRD-MGR', 'on', 'on', ['BSTD'], true, 'both', []],
  ['TUANNT', 'Nguyễn Thanh Tuấn', 'SALE · SALE-SE', 'on', 'on', ['BSTD'], false, 'both', [['Chưa MFA', 'warn']]],
  ['AnNPH', 'Nguyễn Phước An', 'SALE · SALE-SE', 'off', 'on', ['BSTD'], true, 'both', [['Khoá một bên', 'err'], ['Còn license', 'warn']]],
  ['NhiTHT', 'Trần Hoàng Thảo Nhi', 'CSD · CSD-BKG', 'on', 'on', [], true, 'none', [['License bị khoá', 'err'], ['Thiếu ảnh', 'mute']]],
  ['KHAINH', 'Tài xế', 'TRD · TRD-DRV', 'on', 'none', [], false, 'none', [['Chưa có M365', 'warn']]],
  ['thuctap01', '—', 'không có trong HANA Ezy', 'none', 'on', ['BBAS'], false, 'none', [['Mồ côi M365', 'err']]],
  ['ThuyNTT', 'Ngô Thị Thanh Thủy', 'CSD · CSD-CSO', 'on', 'on', ['BSTD'], true, 'both', []],
  ['LIENNTK', 'Nguyễn Thị Kim Liên', 'ACC · ACC-AR', 'on', 'on', ['BSTD'], true, 'm365', [['Ảnh chỉ có ở M365', 'mute']]],
  ['THANHTTK', 'Trương Thị Kim Thành', 'TRD · TRD-DSP', 'on', 'on', ['BSTD', 'EXO'], true, 'both', []],
] as const).map(([un, fn, seat, app, m365, lic, mfa, photo, flags]) => ({ un, fn, seat, app, m365, lic: [...lic], mfa, photo, flags: flags.map((f) => [f[0], f[1]] as [string, Tone]) }));

/** [hộp, mô tả, [người, Full Access, Send As][]] */
export type BoxMember = [string, 0 | 1, 0 | 1];
export const BOXES: [string, string, BoxMember[]][] = [
  ['info@', 'Booking & hãng tàu', [['MAITTN', 1, 1], ['ThuyNTT', 1, 1], ['PhuongHT', 1, 0], ['NhiTHT', 1, 0], ['PHUONGNKT', 1, 0], ['DAVID', 1, 1], ['AnNPH', 1, 0]]],
  ['support@', 'Khách hàng & hoá đơn', [['LIENNTK', 1, 1], ['HANHLTM', 1, 0], ['TUANNT', 1, 0], ['DAVID', 1, 1]]],
  ['trf@', 'Vận tải', [['PHONGNT', 1, 1], ['THANHTTK', 1, 1]]],
  ['hr@', 'Tuyển dụng & HC-NS', [['HANHLTM', 1, 1], ['DAVID', 1, 0]]],
];

/** [lúc, người, việc, đối tượng, hệ] */
export const AUDIT: [string, string, string, string, string][] = [
  ['23/Oct/2026 08:02', 'DAVID', 'Xem tệp OneDrive (chỉ đọc)', 'AnNPH · /Báo giá/2026', 'OneDrive'],
  ['22/Oct/2026 17:40', 'DAVID', 'Thu hồi 2 link chia sẻ ngoài', 'TUANNT', 'OneDrive'],
  ['22/Oct/2026 10:12', 'DAVID', 'Khoá đăng nhập app', 'AnNPH · nghỉ việc', 'HANA Ezy'],
  ['21/Oct/2026 09:30', 'DAVID', 'Cấp Full Access info@', 'NhiTHT', 'M365'],
  ['20/Oct/2026 16:05', 'DAVID', 'Đổi UserName THUYNTT → ThuyNTT', 'gộp hoa thường · 38 list · 1.204 dòng', 'HANA Ezy'],
  ['20/Oct/2026 08:15', 'DAVID', 'Đặt lại mật khẩu M365', 'PHUONGNKT · gửi qua quản lý trực tiếp', 'M365'],
  ['19/Oct/2026 14:22', 'DAVID', 'Đẩy 6 ảnh đại diện lên M365', 'cắt vuông 1:1', 'M365'],
];

export const upn = (un: string) => `${un.toLowerCase().slice(0, 2)}•••@hanalogisticsvn.com`; // che email nhân viên như board
export const initials = (un: string) => un.replace(/[^A-Za-z]/g, '').slice(0, 2).toUpperCase();
